module.exports = __webpack_public_path__ + "de77a722/img/ion_calendar-number.3ac5bd07.svg";